import { render, staticRenderFns } from "./reservationsListPage.vue?vue&type=template&id=26f171d5"
import script from "./reservationsListPage.vue?vue&type=script&lang=js"
export * from "./reservationsListPage.vue?vue&type=script&lang=js"
import style0 from "./reservationsListPage.vue?vue&type=style&index=0&id=26f171d5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports